import { useEffect } from "react";

export const closeAllMenus = (
  openMenu: boolean[],
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean[]>>
) => {
  //if selected menu open value is currently true
  //map through openMenu values
  //set them all to false
  const tempState: boolean[] = [];
  for (let i = 0; i < openMenu.length; i++) {
    tempState.push(false);
  }
  setOpenMenu(tempState);
};

export const openAndCloseMenus = (
  openMenu: boolean[],
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean[]>>,
  index: number
) => {
  const tempState: boolean[] = [];
  //If selected menu open value is currently false
  //map through openMenu values
  //if any values are currently true, make them false
  //set current open menu value to true
  if (!openMenu[index]) {
    for (let i = 0; i < openMenu.length; i++) {
      tempState.push(false);
    }
    tempState[index] = true;
    setOpenMenu(tempState);
  } else {
    closeAllMenus(openMenu, setOpenMenu);
  }
};

export const useEscape = (
  openMenu: boolean[],
  setOpenMenu: React.Dispatch<React.SetStateAction<boolean[]>>
) => {
  useEffect(() => {
    const close = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        closeAllMenus(openMenu, setOpenMenu);
      }
    };
    window.addEventListener("keydown", close);
    return () => window.removeEventListener("keydown", close);
  }, [openMenu, setOpenMenu]);
};
